import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-button-component',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() content: string;
  @Input() valid: boolean;
  @Input() type: string;
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  clicked(): void {
    this.onClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/ButtonComponent/button.component.ts